module.exports = __webpack_public_path__ + "img/a2_p1.191bdc7e.jpg";